import { Link } from '@mui/material';

export const SKIP_TARGET_ID = 'main-content';

export const SkipLink = () => (
  <Link
    href={`#${SKIP_TARGET_ID}`}
    sx={{
      position: 'absolute',
      left: -10000,
      top: 'auto',
      width: 1,
      height: 1,
      overflow: 'hidden',
      '&:focus': {
        position: 'fixed',
        top: 8,
        left: 8,
        width: 'auto',
        height: 'auto',
        px: 2,
        py: 1,
        bgcolor: 'background.paper',
        color: 'primary.main',
        zIndex: (theme) => theme.zIndex.tooltip + 1,
        boxShadow: 3,
        textDecoration: 'underline',
      },
    }}
  >
    Skip to Main Content
  </Link>
);
